import type { MetaDefinition } from '@angular/platform-browser';
import { InjectionToken } from '@angular/core';
import type { MetaDataViewsMapping } from './meta-data.effects';

export const registeredProperties: MetaDefinition[] = [
  { name: 'keywords' },
  { name: 'author' },
  { name: 'description' },
  { name: 'news_keywords' },
  { name: 'robots' },
  { name: 'cXenseParse:articleid' },
  { name: 'cXenseParse:recs:recommendable' },
  { property: 'og:type' },
  { property: 'og:image' },
  { property: 'og:description' },
  { property: 'og:title' },
  { property: 'article:published_time' },
  { property: 'article:modified_time' },
  { property: 'article:tag' },
  { property: 'article:section' },
  { property: 'article:subsection' },
  { property: 'k5a:paid' },
];

export const TT_META_BASE_TITLE = new InjectionToken<string>('TT SHARED - META BASE TITLE');
export const TT_META_DATA_VIEWS_MAPPING = new InjectionToken<MetaDataViewsMapping>('TT SHARED - META VIEWS MAPPING');
